import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';
import styles from './ServiceCard.module.scss';
import { Button } from '../../../shared/ui/Button/Button';
import { Link } from 'react-router-dom';



const ServiceCard = ({element}) => {
    const { img, title, description, btn, src } = element;
    return (    
            <Stack className={styles.card}>       
                <Stack 
                    direction = 'column'   
                    gap = '32'                     
                    alignItems = 'alignStart'
                    justifyContent = 'justifyBetween'         
                    className={styles.service__card}
                >
                    <Stack
                        gap = '32'
                        justifyContent = 'justifyStart'
                        alignItems = 'alignCenter'
                        className={styles.photo__service}
                    >
                        <img className={styles.photo} src={img} alt='услуги'/>
                        <Text size = 'l' className={styles.service__title}>
                            {title}
                        </Text>
                    </Stack>
                        <div className={styles.service__text}>
                            <Text className={styles.text}>
                                {description}
                            </Text>
                                <Button  variant = 'secondary' className={styles.btn}>
                                    <Link to={btn} className={styles.link}>
                                        подробнее услуги и цены
                                    </Link>
                                </Button>   
                        </div> 
                        
                </Stack>
                <img className={styles.picture} src={src} alt='услуги'/>
            </Stack>
    );
}

export default ServiceCard;